'use client'

import { useGetAllProductsMutation } from '@/shared/api-rtk'
import { redirect } from 'next/navigation'
import PaginationBtns from '@/shared/components/Pagination'

export const Pagination = ({
    setConfigRequest,
    currentConfig,
    products,
    setProducts,
    pageQuantity,
    scrollToRef,
    loadMoreCounter,
    changeLoadMoreCounter,
}) => {
    // Не показываем пагинацию, если страниц меньше 2 или товаров нет
    if (pageQuantity < 2 || !products || products.length === 0) {
        return
    }

    const [getALl] = useGetAllProductsMutation()

    const navigate = (path) => redirect(path)

    const hanleLoadMore = async () => {
        try {
            const respose = await getALl({
                ...currentConfig,
                current_page: loadMoreCounter + 1,
            }).unwrap()
            if (respose.result === 'success') {
                setProducts([...products, ...Object.values(respose.data)])
                changeLoadMoreCounter(loadMoreCounter + 1)
            } else {
                throw new Error('Load more products error')
            }
        } catch (error) {
            navigate('/error')
        }
    }

    const handlePaginationButton = async (pageNuber) => {
        try {
            const respose = await getALl({
                ...currentConfig,
                current_page: pageNuber,
            }).unwrap()
            if (respose.result === 'success') {
                setProducts(Object.values(respose.data))
                setConfigRequest({
                    ...currentConfig,
                    current_page: pageNuber,
                })
                changeLoadMoreCounter(pageNuber)

                scrollToRef()
            } else {
                throw new Error('Load more products error')
            }
        } catch (error) {
            navigate('/error')
        }
    }

    const offset = 2

    const limitReviews = pageQuantity > loadMoreCounter

    return (
        <PaginationBtns
            pageQuantity={pageQuantity}
            currentPage={currentConfig.current_page}
            offset={offset}
            handlePaginationButton={handlePaginationButton}
            limitReviews={limitReviews}
            handleShowMore={hanleLoadMore}
        />
    )
}